import { makeStyles } from '@material-ui/styles'
import Theme from '@refera/ui-core'

export default makeStyles(({ spacing }) => ({
  modal: {
    position: 'absolute',
    zIndex: 4,
    top: '40%',
    left: '40%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: spacing(16, 24),
  },
  dialogTitle: {
    color: Theme.Colors.Primary.Base,
    cursor: 'grab',
    width: '100%',

    '&:active': {
      cursor: 'grabbing',
    },
  },
  button: {
    minWidth: spacing(90),
  },

  titleBlue: {
    color: Theme.Colors.Primary.Base,
    cursor: 'grab',
    width: '100%',

    '&:active': {
      cursor: 'grabbing',
    },
  },
}))
